import React, { useEffect, useState, useContext } from "react";
import axios from "../api/axiosInstance";
import DashboardLayout from "./DashboardLayout";
import { useNavigate, Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { getInvoiceList, getInvoiceFinancialList } from "../services/invoiceService";
import { getOpenOrders } from "../services/OpenOrdersService";
import { CustomerContext } from "../context/customerContext";
import { requestPayment } from "../services/FinancialService";


const CustomerInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  // const [customer, setCustomer] = useState(null);
  const { customer, setCustomer } = useContext(CustomerContext);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [openOrders, setOpenOrders] = useState([]);
  const [payingInvoiceId, setPayingInvoiceId] = useState(null);

  const itemsPerPage = 15;
  const navigate = useNavigate();

  // ====================== دریافت فاکتورها ======================
  // const fetchInvoices = async (from = null, to = null) => {
  //   try {
  //     const params = {};
  //     if (from) params.fromDate = from;
  //     if (to) params.toDate = to;

  //     const response = await getInvoiceList(params);

  //     const sortedData = (response.data || []).sort(
  //       (a, b) => new Date(b.date) - new Date(a.date)
  //     );

  //     setInvoices(sortedData);
  //   } catch (error) {
  //     console.error("خطا در دریافت فاکتورها:", error);
  //   }
  // };

  const fetchInvoices = async (from = null, to = null) => {
    try {

      if (!customer) return;

      const params = {
        customerId: customer.customerId
      };

      if (from) params.fromDate = from;
      if (to) params.toDate = to;

      const response = await getInvoiceFinancialList(params);

      const sortedData = (response.data || []).sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );

      setInvoices(sortedData);

    } catch (error) {
      console.error("خطا در دریافت فاکتورها:", error);
    }
  };


  // ====================== دریافت حواله‌ های باز ======================
  const fetchOpenOrders = async (from = null, to = null) => {
    try {
      const params = {};
      if (from) params.fromDate = from;
      if (to) params.toDate = to;

      const response = await getOpenOrders(params);

      const sortedData = (response.data || []).sort(
        (a, b) => new Date(b.orderDate) - new Date(a.orderDate)
      );

      setOpenOrders(sortedData);
    } catch (error) {
      console.error("خطا در دریافت حواله‌های باز:", error);
    }
  };

  //=======================پرداخت آنلاین ======================

  // const isPaymentTestEnabled = customer?.groupID === 3195;
  const isPaymentTestEnabled =
    (customer?.accountGroupID === 2047 ||
      customer?.accountGroupID === 2050 ||
      customer?.accountGroupID === 2042);

  const handleOnlinePayment = async (invoice) => {
    localStorage.setItem("paymentReturnTo", "/customer-invoices");
    const invoiceId = parseInt(invoice.invoiceID, 10);

    if (!invoiceId) {
      alert("شناسه فاکتور نامعتبر است");
      return;
    }

    const amount = Math.round(Number(invoice.remainAmount));

    if (!amount || amount <= 0) {
      alert("مبلغ قابل پرداخت معتبر نیست");
      return;
    }

    if (payingInvoiceId === invoiceId) return;

    setPayingInvoiceId(invoiceId);

    try {
      const payload = {
        InvoiceId: invoiceId,
        Amount: amount,
        Name: customer?.customerName || "",
        Description: `پرداخت شماره فاکتور ${invoice.number}`

      };

      const response = await requestPayment(payload);
      const paymentUrl = response?.data?.paymentUrl;

      if (!paymentUrl) {
        throw new Error("paymentUrl دریافت نشد");
      }

      window.open(paymentUrl, "_self");

    } catch (error) {
      console.error("خطا در اتصال به درگاه:", error);
      alert("خطا در اتصال به درگاه پرداخت");
    } finally {
      setPayingInvoiceId(null);
    }
  };

  // ====================== دکمه فیلتر ======================
  const handleFilter = () => {
    const from = fromDate
      ? fromDate.toDate().toISOString().split("T")[0]
      : null;

    const to = toDate
      ? toDate.toDate().toISOString().split("T")[0]
      : null;

    fetchInvoices(from, to);
    fetchOpenOrders(from, to);
  };

  // ====================== بارگذاری اولیه فاکتورها ======================
  useEffect(() => {
    if (!customer) return;

    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    fetchInvoices(
      sevenDaysAgo.toISOString().split("T")[0],
      today.toISOString().split("T")[0]
    );

  }, [customer]);


  // ====================== بارگذاری اولیه حواله‌های باز ======================
  useEffect(() => {
    if (!customer) return;
    fetchOpenOrders(); // بدون فیلتر
  }, [customer]);

  // صفحه‌بندی:
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentInvoices = invoices.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(invoices.length / itemsPerPage);

  const hasPaymentButton = (inv) =>
    isPaymentTestEnabled && inv.remainAmount > 0;

  const isButtonProcessing = (inv) =>
    hasPaymentButton(inv) &&
    (inv.isPaymentLocked || inv.state === 44 || payingInvoiceId === inv.invoiceID);


  // const isProcessing = (inv) =>
  //   inv.state === 44 ||
  //   (inv.isPaymentLocked || payingInvoiceId === inv.invoiceID);
  // const isProcessing = (inv) =>
  //   inv.remainAmount > 0 &&
  //   (inv.isPaymentLocked || payingInvoiceId === inv.invoiceID);


  return (
    <DashboardLayout>
      <div className="flex items-center justify-between  mb-4">
        <h1 className="text-base sm:text-lg md:text-xl  font-bold text-blue-700">
          فاکتورهای مشتری
        </h1>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
        >
          بازگشت
        </button>
      </div>
      {/* <div className="space-y-6"> */}
      <div className="bg-white p-4 rounded shadow text-sm space-y-4">
        {/* ✅ فیلدهای تاریخ در یک ردیف واکنش‌گرا حتی در موبایل */}
        <div className="flex flex-wrap items-center gap-y-2 gap-x-2 sm:gap-x-4">
          {/* از تاریخ */}
          <div className="flex items-center gap-1 whitespace-nowrap">
            <span className="text-sm">از تاریخ:</span>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={fromDate}
              onChange={setFromDate}
              format="YYYY/MM/DD"
              inputClass="border rounded px-1 py-1 w-24 sm:w-28 md:w-32 lg:w-36 text-center text-xs sm:text-sm"
            />
          </div>

          {/* تا تاریخ */}
          <div className="flex items-center gap-1 whitespace-nowrap">
            <span className="text-sm">تا تاریخ:</span>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={toDate}
              onChange={setToDate}
              format="YYYY/MM/DD"
              inputClass="border rounded px-1 py-1 w-24 sm:w-28 md:w-32 lg:w-36 text-center text-xs sm:text-sm"
            />
          </div>
          {/* دکمه فیلتر */}
          <div className="sm:mt-0 w-full sm:w-auto">
            <button
              onClick={handleFilter}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-500 w-full sm:w-auto"
            >
              اعمال فیلتر
            </button>
          </div>
        </div>

        {/* توضیح */}
        <p className="text-gray-600 text-xs">
          گزارش فاکتور حداکثر تا ۶۰ روز گذشته
        </p>
      </div>

      {/* ✅ جدول فاکتورها */}
      {/* <table className="w-full text-sm text-right bg-white shadow rounded-xl overflow-x-auto"> */}
      <div className="w-full overflow-x-auto rounded-xl">
        <table className="w-full min-w-[600px] text-sm text-right bg-white shadow rounded-xl overflow-hidden">
          <thead className="bg-blue-100 text-blue-900">
            <tr>
              <th className="px-2 py-1 sm:p-3">ردیف</th>
              <th className="px-2 py-1 sm:p-3">شماره فاکتور</th>
              <th className="px-2 py-1 sm:p-3">تاریخ</th>
              <th className="px-2 py-1 sm:p-3">مبلغ (ریال)</th>
              <th className="px-2 py-1 sm:p-3">وضعیت تسویه</th>
              <th className="px-2 py-1 sm:p-3">مانده تسویه نشده</th>
              <th className="px-2 py-1 sm:p-3"></th>
            </tr>
          </thead>
          <tbody>
            {/* ====================== بخش حواله‌های باز ====================== */}
            {openOrders.length > 0 &&
              openOrders.map((or, index) => (
                <tr
                  key={`open-${or.orderItemID}`}
                  className="border-t bg-yellow-50 hover:bg-yellow-100"
                >
                  {/* ردیف */}
                  <td className="px-2 py-1 sm:p-3 font-bold">
                    __
                  </td>

                  {/* شماره حواله */}
                  <td className="px-2 py-1 sm:p-3 text-blue-700 font-bold">
                    <Link
                      to={`/openOrder-details/${or.orderID}`}
                      state={{
                        number: or.orderNumber,
                        date: or.orderDate,
                        customerName: customer?.customerName,
                        customerCode: customer?.customerCode,
                      }}
                      className="hover:underline"
                    >
                      {or.orderNumber}
                    </Link>
                  </td>

                  {/* تاریخ حواله */}
                  <td className="px-2 py-1 sm:p-3">
                    {new DateObject({
                      date: or.orderDate,
                      calendar: "gregorian",
                    })
                      .convert(persian)
                      .format("YYYY/MM/DD")}
                  </td>

                  {/* مبلغ */}
                  <td className="px-2 py-1 sm:p-3">
                    {or.netPrice?.toLocaleString()}
                  </td>

                  {/*  وضعیت تسویه (خالی) */}
                  <td className="px-2 py-1 sm:p-3  text-red-600 font-bold">
                    حواله تحویل نشده
                  </td>

                  {/*  مانده تسویه نشده (خالی) */}
                  <td className="px-2 py-1 sm:p-3"></td>
                </tr>
              ))}

            {/* ====================== بخش فاکتورها ====================== */}
            {currentInvoices.map((inv, index) => (
              <tr key={inv.id} className="border-t hover:bg-blue-50">
                {/* شماره ردیف */}
                <td className="px-2 py-1 sm:p-3">{index + 1}</td>

                {/* شماره فاکتور */}
                <td className="px-2 py-1 sm:p-3 text-blue-700 font-bold">
                  <Link
                    to={`/invoice-details/${inv.invoiceID}`}
                    state={{
                      number: inv.number,
                      date: inv.date,
                      customerName: customer?.customerName,
                      customerCode: customer?.customerCode,
                    }}
                    className="hover:underline"
                  >
                    {inv.number}
                  </Link>
                </td>

                {/* تاریخ فاکتور */}
                <td className="px-2 py-1 sm:p-3">
                  {new DateObject({
                    date: inv.date,
                    calendar: "gregorian",
                  })
                    .convert(persian)
                    .format("YYYY/MM/DD")}
                </td>

                {/* مبلغ */}
                <td className="px-2 py-1 sm:p-3">
                  {inv.netPrice.toLocaleString()}
                </td>

                {/* وضعیت تسویه */}
                <td className="px-2 py-1 sm:p-3">
                  {/* {inv.stateString} */}
                  <span
                    className={`font-medium ${isButtonProcessing(inv) ? "text-yellow-700" : "text-gray-700"
                      }`}
                  >
                    {isButtonProcessing(inv) ? "در حال تسویه" : inv.stateString}
                  </span>
                </td>

                {/* مانده */}
                <td className="px-2 py-1 sm:p-3">
                  {inv.remainAmount != null && inv.remainAmount !== 0
                    ? inv.remainAmount.toLocaleString()
                    : ""}
                </td>
                {/*پرداخت آنلاین */}
                <td className="px-2 py-1 sm:p-3 text-center">

                  {isPaymentTestEnabled &&
                    inv.remainAmount > 0 && (
                      <button
                        // disabled={
                        //   payingInvoiceId === inv.invoiceID ||
                        //   inv.state === 44 ||
                        //   inv.isPaymentLocked
                        // }
                        disabled={isButtonProcessing(inv)}
                        onClick={() => handleOnlinePayment(inv)}
                        className={`text-white text-[11px] sm:text-xs font-medium py-1 px-2.5 rounded-md shadow-sm transition-all
                         ${inv.isPaymentLocked || inv.state === 44
                            ? "bg-yellow-400 cursor-not-allowed"
                            : payingInvoiceId === inv.invoiceID
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-blue-600 hover:bg-blue-700 hover:scale-105"
                          }`}
                      >
                        {/* {inv.isPaymentLocked || inv.state === 44
                          ? "در حال تسویه"
                          : payingInvoiceId === inv.invoiceID
                            ? "در حال اتصال..."
                            : "پرداخت"} */}
                        {isButtonProcessing(inv)
                          ? "در حال تسویه"
                          : payingInvoiceId === inv.invoiceID
                            ? "در حال اتصال..."
                            : "پرداخت"}
                      </button>
                    )}

                </td>
              </tr>
            ))}

            {/* ====================== اگر هیچ داده‌ای نبود ====================== */}
            {openOrders.length === 0 && invoices.length === 0 && (
              <tr>
                <td colSpan="6" className="p-4 text-center text-gray-500">
                  هیچ فاکتور یا حواله بازی یافت نشد.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-4 flex-wrap">
          {/* دکمه قبلی */}
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className={`px-3 py-1 rounded ${currentPage === 1 ? "bg-gray-300 text-gray-600" : "bg-blue-100"
              }`}
          >
            قبلی
          </button>

          {/* صفحه‌ها - فقط ۵ عدد نمایش داده شود */}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) => {
              if (totalPages <= 5) return true;
              if (currentPage <= 3) return page <= 5;
              if (currentPage >= totalPages - 2) return page >= totalPages - 4;
              return Math.abs(currentPage - page) <= 2;
            })
            .map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-3 py-1 rounded ${currentPage === page
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
                  }`}
              >
                {page}
              </button>
            ))}

          {/* دکمه بعدی */}
          <button
            disabled={currentPage === totalPages}
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            className={`px-3 py-1 rounded ${currentPage === totalPages
              ? "bg-gray-300 text-gray-600"
              : "bg-blue-100"
              }`}
          >
            بعدی
          </button>
        </div>
      )}
      {/* </div> */}
    </DashboardLayout>
  );
};

export default CustomerInvoices;
